import type { IProductData } from '../../types/affiliates.types';
import type { CpHandler } from './productCard';
import { byOrderUI, toLogos } from './productCard';
import WbdProductCard from './customCps/WbdProductCard';

const STATUS_PRIORITY = [['BOUND'], ['BINDING_PENDING', 'PENDING_UPDATE'], ['SUSPENDED']];

const bindingTime = (product: IProductData) =>
  new Date(product.binding?.updatedAt || product.binding?.createdAt || 0).getTime();

function pickPrimary(products: IProductData[]): IProductData {
  for (const statuses of STATUS_PRIORITY) {
    const matches = products.filter(product => statuses.includes(product.binding?.status));
    if (matches.length) {
      return [...matches].sort((a, b) => bindingTime(b) - bindingTime(a))[0];
    }
  }

  return [...products].sort(byOrderUI)[0];
}

const wbdProductCard: CpHandler = products => {
  if (!products.length) {
    return [];
  }

  const primary = pickPrimary(products);

  return [
    {
      key: `${primary.cps}-${primary.bindingId}`,
      cps: primary.cps,
      logos: toLogos(products),
      primary,
      products: [...products].sort(byOrderUI),
      bindingId: primary.bindingId,
      Component: WbdProductCard
    }
  ];
};

export default wbdProductCard;
